/* eslint-disable class-methods-use-this */
import axios from "axios";
import _ from "lodash";

import {API_PAYMENT_TRANSACTION_URL, COMMON_HEADER_CONFIG} from "../config";

class PaymentTransactionService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListPaymentTransactions = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PAYMENT_TRANSACTION_URL}/payment-transaction`,
        params: {
          size: 500,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      if (!_.isEmpty(data)) {
        config.params = {...config.params, ...data};
      }

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createPaymentTransaction = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_PAYMENT_TRANSACTION_URL}/payment-transaction`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const paymentTransactionService = new PaymentTransactionService();

export default paymentTransactionService;
